import { Button, Card, CardActions, CardContent, CardHeader, Divider, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { ErrorMessage } from "components";
import LoadingIndicator from "components/LoadingIndicator";
import MonoText from "components/MonoText";
import PropTypes from "prop-types";
import React, { Fragment, useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { ItemClass } from "services";
import useErrorCatcher from "utils/useErrorCatcher";

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(3),
  },
  content: {
  },
  actions: {
    flexDirection: "column",
    alignItems: "flex-start",
    "& > * + *": {
      marginLeft: 0
    }
  },
  notice: {
    marginTop: theme.spacing(1)
  },
  italics_light: {
    opacity: 0.7,
    fontStyle: "italic",
  },
  spinner: {
    marginTop: theme.spacing(3),
  },
  mono: {
    fontFamily: ["Roboto Mono", "monospace"],
  },
}));

let mounted = false;
const ItemClassPreview = props => {
  const { itemClassId, itemClass, className, ...rest } = props;
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [model, setModel] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const runAsyncBlock = useErrorCatcher(error => setErrorMessage(error && error.message));

  useEffect(() => {
    mounted = true;
    return () => mounted = false;
  }, [])

  useEffect(() => {
    if (itemClass) {
      if (mounted) setModel(itemClass);
    } else if (itemClassId && !itemClass) {
      runAsyncBlock(async () => {
        const { model } = await ItemClass.detail(itemClassId);
        if (mounted) setModel(model);
      }).finally(() => mounted && setLoading(false));
    }
    // eslint-disable-next-line
  }, [itemClassId, itemClass]);

  if (!(itemClassId || itemClass)) return null;

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardHeader title="Item Class" />
      <Divider />
      <CardContent className={classes.content}>
        <ErrorMessage message={errorMessage} />
        <LoadingIndicator className={classes.spinner} variant="card" active={loading} />
        {model && (
          <Fragment>
            <Typography variant="h3">{model.label}</Typography>
            <Typography variant="body1" >{model.name}</Typography>
            <Typography className={classes.mono} variant="body1" >
              <MonoText>{model.reference}</MonoText></Typography>
          </Fragment>
        )}
      </CardContent>
      <CardActions className={classes.actions}>
        <Button component={RouterLink} size="small" to={`/item-classes/${((itemClass && itemClass.id) || itemClassId)}/summary`}>
          View Item Class Details
        </Button>
      </CardActions>
    </Card>
  );
};

ItemClassPreview.propTypes = {
  className: PropTypes.string,
};

export default ItemClassPreview;
